module.exports = __webpack_public_path__ + "img/ico-zoom-out.bf2046a9.svg";